import { chartNames, rumEvents } from "../../consts";

const marketEvents = [
  rumEvents.CONNECT_DEVICE,
  rumEvents.ADVANCED_DIAGNOSTIC_COMPLETED,
  rumEvents.ADVANCED_DIAGNOSTIC_PROCESS,
  rumEvents.FIRMWARE_UPDATE
];

const marketChartIds = [
  chartNames.IQOS_DEVICE_CONNECTIONS_COUNT,
  chartNames.FWU_COUNT,
  chartNames.AD_COUNT
];

const chartIds = [
  chartNames.PAGE_LOADS,
  chartNames.AVG_PAGE_LOAD_SPEED,
  chartNames.CONNECTION_TIME,
  chartNames.IQOS_DEVICE_USAGE,
  chartNames.OS,
  chartNames.BROWSER,

  chartNames.FWU_STATISTICS,
  chartNames.FWU_PERFORMANCE,
  chartNames.FWU_ERRORS,
  chartNames.RECONNECTION_TIME_DURING_FWU,

  chartNames.AD_STATISTICS,
  chartNames.DIAGNOSTICS_PERFORMANCE,
  chartNames.DIAGNOSTICS_ERRORS_READING_PERFOMANCE,

  chartNames.SETTING_USAGE,
  chartNames.SETTING_PERFOMANCE,

  chartNames.BATTERY_HEALTH_STATISTICS,
  chartNames.BATTERY_HEALTH_PERFORMANCE
];

const marketAdminChartIds = [
  chartNames.IQOS_DEVICE_CONNECTIONS_COUNT,
  chartNames.FWU_STATISTICS,
  chartNames.AD_STATISTICS,
  chartNames.SETTING_USAGE
];

const marketAdminRumEvents = [
  rumEvents.FIRMWARE_UPDATE,
  rumEvents.ADVANCED_DIAGNOSTIC_COMPLETED,
  rumEvents.SETTINGS
];

const marketAdminMarketRumEvents = [rumEvents.CONNECT_DEVICE];

export {
  marketEvents,
  marketChartIds,
  chartIds,
  marketAdminChartIds,
  marketAdminRumEvents,
  marketAdminMarketRumEvents
};
